var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ pageloader: true, 'is-active': _vm.active }},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.message || 'Loading'))])])}
var staticRenderFns = []

export { render, staticRenderFns }